import React, { useState, useEffect } from "react";
import "Style/Layouts/dashboardLayout.scss";
import { ToastContainer } from "react-toastify";
import DashboardHeader from "./Components/DashboardHeader";
import DashboardSideBar from "./Components/DashboardSideBar";

interface Props {
  Component: any;
  
}

const DashboardLayout: React.FC<Props> = ({ Component }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(true);
  
  return (
    <>
      <div className="desktop dashboard-main-parent">
        <DashboardSideBar isDrawerOpen={isDrawerOpen} />
        <div style={{ width: "100%", transition: "0.2s", maxWidth:isDrawerOpen ? 'calc(100% - 230px)' : 'calc(100% - 80px)' }}>
          <DashboardHeader
            setIsDrawerOpen={setIsDrawerOpen}
            isDrawerOpen={isDrawerOpen}
          />
          <div className="component-container">{Component}</div>
        </div>
      </div>
      <ToastContainer
        autoClose={3000}
        position="top-left"
        className="toast-container"
      />
    </>
  );
};

export default DashboardLayout;
